<div *ngIf="isLoading" class="loading-shade">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
